
import React, { Component } from 'react'
import CreateTicketDetail from './CreateTicketDetail'
import ViewTicketDetail from './ViewTicketDetail'
import { getCookie } from "../../../helpers/cookieHelper";
import { getUserId } from "../../../helpers/AuthHelper";

import { Messager } from 'rc-easyui';
import { getPriorityID, getProjectID, getTicketTypeId, getTicketStatusId, getAssigneId } from './TicketAPI';

export default class TicketDetail extends Component {
  constructor() {
    super()
    this.childRef = React.createRef()
    this.state = {
      Ticket: {
        summary: "",
        description: "",
        linkedTicket: "",
        projectId: "",
        assigneeId: "",
        priorityId: "",
        ticketTypeId: "",
        statusId: "",
        enabled: '',
        privateTicket: '',
        estimate: "",
        expectedCompletionDateAd: '',
        createdBy: getUserId(),
        workLog: "",
        comments: ""

      },

      projectList: [],
      priorityList: [],
      ticketTypeList: [],
      StatusList: [],
      userList: [],
      rules: {
        summary: ['required'],
        description: ['required'],
        // linkedTicket: ['required'],
        // estimate: ['required'],
        // workLog: ['required'],
        // comments: ['required'],

      },
      enableStatus: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" }
      ],
      privateTicketStatus: [
        { value: true, text: "True" },
        { value: false, text: "False" }

      ],
      isLoading: true,
      operation: "Add",
      selected: {},
      permissions: [],

    }


  }
  componentDidMount = async () => {
    var data = getCookie('permission');
    const date = new Date();
    let fullYear = date.getFullYear();
    let fullMonth = date.getMonth()
    let fullDay = date.getDate()
    let formattedDate = fullYear + '-' + (fullMonth + 1) + '-' + fullDay
    const today = formattedDate;

    this.setState({
      permissions: JSON.parse(data),
      Ticket: {
        summary: "",
        description: "",
        linkedTicket: "",
        projectId: "",
        assigneeId: "",
        priorityId: "",
        ticketTypeId: "",
        statusId: "",
        enabled: true,
        privateTicket: true,
        estimate: "",
        expectedCompletionDateAd: new Date(today),
        createdBy: getUserId(),
        workLog: "",
        comments: ""

      },

      projectList: await getProjectID(),
      priorityList: await getPriorityID(),
      ticketTypeList: await getTicketTypeId(),
      StatusList: await getTicketStatusId(),
      userList: await getAssigneId()
    }, () => {
      const Ticket = { ...this.state.Ticket }
      Ticket['assigneeId'] = this.state.userList[0].id;
      Ticket['priorityId'] = this.state.priorityList[0].id;
      Ticket['ticketTypeId'] = this.state.ticketTypeList[0].id;
      Ticket['statusId'] = this.state.StatusList[0].id;
      Ticket['projectId']=this.state.projectList[0].id
      this.setState({
        isLoading: false,
        Ticket: Ticket
      })
      // console.log(this.state.userList[0].id);

    });
  }



  handleInput = (name, value) => {

    const newArr = { ...this.state.Ticket }
    newArr[name] = value
    this.setState({
      Ticket: newArr

    })

  }
  formClear = async () => {
    // console.log("inside formclear");
    var data = getCookie('permission');
    const date = new Date();
    let fullYear = date.getFullYear();
    let fullMonth = date.getMonth()
    let fullDay = date.getDate()
    let formattedDate = fullYear + '-' + (fullMonth + 1) + '-' + fullDay
    const today = formattedDate;

    this.setState({
      permissions: JSON.parse(data),
      Ticket: {
        summary: "",
        description: "",
        linkedTicket: "",
        projectId: "",
        assigneeId: "",
        priorityId: "",
        ticketTypeId: "",
        statusId: "",
        enabled: null,
        privateTicket: null,
        estimate: "",
        expectedCompletionDateAd: new Date(today),
        createdBy: getUserId(),
        workLog: "",
        comments: ""

      },

      projectList: await getProjectID(),
      priorityList: await getPriorityID(),
      ticketTypeList: await getTicketTypeId(),
      StatusList: await getTicketStatusId(),
      userList: await getAssigneId()
    }, () => {
      const Ticket = { ...this.state.Ticket }
      Ticket['assigneeId'] = this.state.userList[0].id;
      Ticket['priorityId'] = this.state.priorityList[0].id;
      Ticket['ticketTypeId'] = this.state.ticketTypeList[0].id;
      Ticket['statusId'] = this.state.StatusList[0].id;
      this.setState({
        isLoading: false,
        Ticket: Ticket
      })
      // console.log(this.state.userList[0].id);

    });
  }

  onSelectionChange = (selectedRow) => {

    if(selectedRow){
      return this.props.history.push(`/update-detail-page/?id=${selectedRow.id}`)
    }

    this.setState({
      selected: selectedRow,
    });
  }





  render() {
    const { permissions } = this.state;

    return (
      <div className='container-fluid'>

        <div className='loadingmodel'
          style={{ display: this.state.isLoading ? 'block' : 'none' }}></div>



        <div className='row' >
          <Messager
            className='Notification_Middle'
            ref={ref => this.messager = ref}></Messager>

          {permissions.includes("ticket-create") ? (
            <div className='col-md-4'>
              <CreateTicketDetail
                Ticket={this.state.Ticket}
                handleInput={this.handleInput}
                projectList={this.state.projectList}
                priorityList={this.state.priorityList}
                ticketTypeList={this.state.ticketTypeList}
                StatusList={this.state.StatusList}
                userList={this.state.userList}
                enableStatus={this.state.enableStatus}
                privateTicketStatus={this.state.privateTicketStatus}
                operation={this.state.operation}
                rules={this.state.rules}
                ref={this.childRef}
                formClear={this.formClear}
                workLogs={this.state.work}
                handleEstimate={this.handleEstimate}
              />
            </div>
          ) : null}
          {permissions.includes("ticket-view") ? (
            <div className='col-md-8'>
              <ViewTicketDetail
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                selectedRow={this.state.selected}
                enableStatus={this.state.enableStatus}
                privateTicketStatus={this.state.privateTicketStatus}
                permissions={this.state.permissions}
                StatusList={this.state.StatusList}
                projectList={this.state.projectList}
                priorityList={this.state.priorityList}
                userList={this.state.userList}
              />
            </div>) : null}

        </div>
      </div>


    )
  }
}
